import React, { FC } from 'react'
import { breakpointDown, styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Grid, Box } from '@moonpig/launchpad-components'
import { ModuleTwoColumnProductHeading, Module, ModuleContext } from '../types'

type Props = {
  module: ModuleTwoColumnProductHeading
  context: ModuleContext
  map: (module: Module, props: ModuleContext) => React.JSX.Element | null
}

const StyledColumnLeft = styled(Box)`
  width: 60%;
  ${s({
    p: 0,
    m: 0,
    mb: 10,
    pl: 10,
  })}
  ${breakpointDown('md')} {
    ${s({
      pl: 8,
    })}
  }
  ${breakpointDown('sm')} {
    width: 100%;
    ${s({
      pl: 8,
      mb: 5,
    })}
  }
`

const StyledColumnRight = styled(Box)`
  width: 40%;
  ${s({
    p: 0,
    m: 0,
    mb: 10,
    pr: 4,
  })}
  ${breakpointDown('sm')} {
    width: 100%;
    ${s({
      mb: 5,
      pl: 8,
    })}
  }
`

export const TwoColumnProductHeadingModule: FC<Props> = ({
  module: { left, right },
  context,
  map,
}) => {
  return (
    <Grid data-testid="module-two-column-product-heading" gap p={0} m={0}>
      <StyledColumnLeft>
        {left.map((m, key) => map(m, { ...context, key }))}
      </StyledColumnLeft>
      <StyledColumnRight>
        {right.map((m, key) => map(m, { ...context, key }))}
      </StyledColumnRight>
    </Grid>
  )
}
